export enum BannerCategory {
    quickLinks = 'quickLinks',
    promotions = 'promotions',
    skyscrapers = 'skyscrapers',
    virtuals = 'virtuals',
    games = 'games',
    promotedTournaments = 'promotedTournaments'
}

export enum ActionType {
    openPopup = 'openPopup',
    openNewTab = 'openNewTab',
    openInAppLink = 'openInAppLink',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/banners/enums.ts